import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import Radium from "radium";
import styleWrap from "../../globalHelpers/GlobalStyleWrapper";

class Spinner extends Component {
    constructor(props, context) {
        super(props);

        this.state = {
            component: {},
            loading: true,
        };
    }

    componentDidMount() {
        if (window.sessionStorage.getItem("Spinner")) {
            const component = JSON.parse(
                window.sessionStorage.getItem("Spinner")
            );

            this.setState({ component, loading: false });
            return;
        }

        Express.callPublic(
            "fetch-component",
            { componentName: "Spinner" },
            (component) => {
                styleWrap(component.style, (styleMap) => {
                    component.style = styleMap;
                    this.setState({ component, loading: false });
                    window.sessionStorage.setItem(
                        "Spinner",
                        JSON.stringify(component)
                    );
                });
            }
        );
    }

    render() {
        try {
            if (this.state.loading) {
                return <div />;
            }
            return (
                <img
                    style={{
                        ...this.props.style,
                        ...this.state.component.style,
                    }}
                    width={this.props.width || "100%"}
                    height={this.props.height || "auto"}
                    src={this.state.component.src}
                    alt={"Spinner"}
                />
            );
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }
}

export default Radium(Spinner);
